import styles from "./questionImage.module.scss";
import { prepareQuestionImageUrl } from "./common";
import { Dialog } from "@kunduz/ui-molecules";

export const QuestionImageModal = (props: Props) => {
  return (
    <Dialog opened={props.visible} close={props.onClose} closeOnClickOutside>
      <div className={styles["questionImageModal"]}>
        <img
          src={prepareQuestionImageUrl(props.imageUrl, 1024)}
          alt={props.imageAlt}
        />
      </div>
    </Dialog>
  );
};

interface Props {
  visible: boolean;
  onClose: () => void;
  imageUrl: string;
  imageAlt?: string;
}
